import React from 'react';

import { isNil } from 'lodash';
import PropTypes from 'prop-types';

import 'components/Event/EventRegisterForm/EventRegisterForm.scss';

import './ParticipantsTable.scss';

export const ParticipantsTable = ({ participants }) => {
  if (!participants.length || isNil(participants)) {
    return (
      <div className="table__collection__absentParticipants">Keine registrierten Teilnehmer</div>
    );
  }

  const preppedParticipants = participants
    .map((participantObject) => {
      const { companyName } = participantObject;
      const { installerId } = participantObject;
      const { participants: eventParticipants } = participantObject;
      return eventParticipants.map((participant) => ({
        contactEmail: participant.eMail,
        firstName: participant.firstName,
        installerId,
        companyName,
        lastName: participant.lastName,
        accountEmail: participant.installerEmail,
      }));
    })
    .flat();

  return (
    <div className="table">
      <table className="table__collection">
        <thead className="table__collection__head">
          <tr>
            <th className="table__collection__header">Firma</th>
            <th className="table__collection__header">Name</th>
            <th className="table__collection__header">Installateurnummer</th>
            <th className="table__collection__header">Kontakt E-Mail-Adresse</th>
            <th className="table__collection__header">E-fix Account E-Mail-Adresse</th>
          </tr>
        </thead>
        <tbody className="table__collection__row">
          {preppedParticipants.map((item, index) => (
            <tr key={index}>
              <td className="table__collection__cell">{item.companyName}</td>
              <td className="table__collection__cell">
                {item.firstName} {item.lastName}
              </td>
              <td className="table__collection__cell">{item.installerId}</td>
              <td className="table__collection__cell">{item.contactEmail}</td>
              <td className="table__collection__cell">{item.accountEmail}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

ParticipantsTable.propTypes = {
  participants: PropTypes.array.isRequired,
};
